import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ResultPageModel } from '../../Core/SortingAndPaging/Models/ResultPageModel';
import { FundProduct } from '../../Models/Domains/Investment/FundProduct';
import { FundProductsQuery } from '../../Models/Domains/Investment/FundProductsQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class FundProductsSearchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: FundProductsQuery, hierarchyId: string): Promise<ResultPageModel<FundProduct>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/FundProductsSearch/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query, hierarchyId: hierarchyId }

    return AjaxWrapper.post<ResultPageModel<FundProduct>, any>(url, data);
  }
}

